import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { useBinaryExperiment } from '../useBinaryExperiment';

export const AlwaysOnExperiment = () => {
  useBinaryExperiment(FLAG.SWA_ALWAYS_ON, { triggerExperiment: true });

  return null;
};
